import React from 'react';

const CertificateConfirmationPopup = ({ onClose, onConfirm }) => {
    return (
        <div className="modal fade show"
          style={{
                display: 'block',
                backgroundColor: 'rgba(0,0,0,0.5)',
                backdropFilter: 'blur(2px)'
            }}
         >
            <div className="modal-dialog certification-modal confirmation-modal-width">
                <div className="modal-content">
                    <div className="modal-header border-0">
                        <button 
                            type="button" 
                            className="btn-close font-12" 
                            onClick={onClose}
                            aria-label="Close"
                        ></button>
                    </div>
                    <div className="modal-body">
                        <div className="d-flex flex-column align-items-center justify-content-center">
                            <img 
                                src="Images/complete-popup-icon.svg" 
                                alt="completed-icon" 
                                className="mb-3"
                            />
                            <p className="font-14 semibold-text text-center">
                                Are you sure you want to mark this as paid?
                            </p>
                            <p className="font-12 semibold-text grey-text text-center mt-1">
                                This action cannot be undone.
                            </p>
                        </div>
                    </div>
                    <div className="modal-footer border-0">
                        <div className="col-md-12 d-flex justify-content-center">
                            <button 
                                className="btn hive-btn-secondary me-3"
                                onClick={onClose}
                            >
                                No
                            </button>
                            <button 
                                className="btn hive-btn-primary"
                                onClick={onConfirm}
                            >
                                Yes
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CertificateConfirmationPopup;